





























import { AppCode, PhoneNumber } from '@/pages/PhoneNumberManagement/types/phone-number'
import { Component, Vue } from 'vue-property-decorator'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import AvailableNumberTable from '@/pages/PhoneNumberManagement/AvailableNumberTable.vue'
import LocationNumberTable from '@/pages/PhoneNumberManagement/LocationNumberTable.vue'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'


interface RequestPayload {
    pulsemAccountId: number|null;
    phoneNumber: PhoneNumber|null;
    appCode: AppCode|null;
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard,
        AvailableNumberTable,
        LocationNumberTable
    }
})
export default class PhoneNumberManagement extends Vue {
    locationValid = false
    loading = true
    pulsemAccountId: null|number = null
    phoneNumber: PhoneNumber|null = null
    appCode: AppCode|null = null
    appCodes: AppCode[] = Object.values(AppCode)

    /**
     * Server request payload to `support/phone-number-management/submit` end point
     */
    get requestPayload(): RequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId,
            phoneNumber: this.phoneNumber,
            appCode: this.appCode
        }
    }

    onLocationChange(locationValid: boolean) {
        this.locationValid = locationValid
    }

    onSuccess(status: boolean) {
        if (status) {
            this.pulsemAccountId = null
            this.phoneNumber = null
            this.appCode = null
        }
    }
}
